module.exports = __webpack_public_path__ + "images/9b47fe9c.png";